import {
  Autocomplete,
  Box,
  Button,
  IconButton,
  TextField,
  Typography,
} from "@mui/material"
import { useEffect, useState } from "react"
import { Link } from "react-router-dom"
import BasicModal from "../../components/alertModal"
import { images } from "../../utils"
import { lists } from "../../utils"
import useStyles from "./style"
import { isEmail, isEmpty } from "../../validators/validator"
import PqrType from "../../components/pqrType"
import { icons } from "../../utils"
import MuiPhoneNumber from "material-ui-phone-number"
import form from "../../services/form"
import { useParams } from "react-router-dom"
import Loader from "../../components/loader"

const Form = () => {
  const classes = useStyles()
  const [open, setOpen] = useState(false)
  const [stateList, setStateList] = useState([])
  const [servicesList, setServicesList] = useState([])
  const [whoResidesList, setWhoResidesList] = useState([])
  const [sedesList, setSedesList] = useState([])
  const [epsList, setEpsList] = useState([])
  const [pqrTypeList, setPqrTypeList] = useState([])
  const [genderList, setGenderList] = useState([])
  const [documentTypeList, setDocumentTypeList] = useState([])
  const [countiesList, setCountiesList] = useState([])
  const [ticketData, setTicketData] = useState({})

  const [flag, setFlag] = useState(false)
  const [fileErrorNum, setFileErrorNum] = useState(false)
  const [fileErrorType, setFileErrorType] = useState(false)
  const [fileErrorSize, setFileErrorSize] = useState(false)
  const [fileFlag, setFileFlag] = useState(false)
  const [isLoading, setIsLoading] = useState(true)
  const [sendingData, setSendingData] = useState(false)
  const [errorModal, setErrorModal] = useState(false)

  let params = useParams()
  const [data, setData] = useState({})

  useEffect(() => {
    const getUser = async () => {
      try {
        const user = await form.user(params.document_type, params.document_num)
        user?.id
          ? setData({
              full_name: user?.full_name ? user.full_name : undefined,
              email: user?.email ? user.email : undefined,
              age: user?.age ? user.age : undefined,
              document_type: user?.document_type
                ? user.document_type
                : params.document_type,
              document_number: user?.document_number
                ? user.document_number
                : params.document_num,
              gender: user?.gender ? user.gender : undefined,
              phone_number: user?.phone_number ? user.phone_number : undefined,
              address: user?.address ? user.address : undefined,
              county_id: user?.county_id ? user.county_id : undefined,
              state_id: user?.state_id ? user.state_id : undefined,
              headquarter: undefined,
              description: undefined,
              eps: undefined,
              settled_by: undefined,
              service: undefined,
              ticket_type: undefined,
              user_id: user?.id,
            })
          : setData({
              full_name: user?.full_name ? user.full_name : undefined,
              email: user?.email ? user.email : undefined,
              age: user?.age ? user.age : undefined,
              document_type: user?.document_type
                ? user.document_type
                : params.document_type,
              document_number: user?.document_number
                ? user.document_number
                : params.document_num,
              gender: user?.gender ? user.gender : undefined,
              phone_number: user?.phone_number ? user.phone_number : undefined,
              address: user?.address ? user.address : undefined,
              county_id: user?.county_id ? user.county_id : undefined,
              state_id: user?.state_id ? user.state_id : undefined,
              headquarter: undefined,
              description: undefined,
              eps: undefined,
              settled_by: undefined,
              service: undefined,
              ticket_type: undefined,
            })

        setIsLoading(false)
      } catch (error) {
        setIsLoading(false)
      }
    }
    getUser()
  }, [params])

  const getStates = async () => {
    const response = await form.states()
    setStateList(response)
  }

  const getSedes = async () => {
    const response = await form.headquarter()
    setSedesList(response)
  }

  const getWhoResides = async () => {
    const response = await form.whoResides()
    setWhoResidesList(response)
  }

  const getPqrType = async () => {
    const response = await form.pqrType()
    setPqrTypeList(response)
  }

  const getServices = async () => {
    const response = await form.services()
    setServicesList(response)
  }

  const getEps = async () => {
    const response = await form.eps()
    setEpsList(response)
  }

  const getGender = async () => {
    const response = await form.gender()
    setGenderList(response)
  }

  const getDocumentType = async () => {
    const response = await form.documentType()
    setDocumentTypeList(response)
  }

  const getCounties = async (id) => {
    const response = await form.counties(id)
    setCountiesList(response)
  }

  useEffect(() => {
    if (flag === false) {
      getStates()
      getServices()
      getEps()
      getGender()
      getSedes()
      getWhoResides()
      getPqrType()
      getDocumentType()
    }
    if (data?.state_id) {
      getCounties(data.state_id)
    }
    setFlag(true)
  }, [data.state_id, flag])

  const handleSubmit = async () => {
    const formData = new FormData()
    // eslint-disable-next-line array-callback-return
    Object.entries(data).map(([key, value]) => {
      if (key !== "documents") {
        formData.append(key, value)
      }
    })
    for (let i = 0; i < data?.documents?.length; i++) {
      formData.append(`documents${i}`, data.documents[i])
    }
    setSendingData(true)
    try {
      const response = await form.sendPqr(formData)
      if (response.data === null) {
        setErrorModal(true)
      } else {
        setTicketData(response?.data)
        if (!data?.user_id && response?.data?.user_id) {
          setData({
            ...data,
            user_id: response?.data?.user_id,
          })
        }
      }
      setSendingData(false)
      setOpen(true)
    } catch (error) {
      setIsLoading(false)
      setErrorModal(true)
    }
  }

  const handleClose = () => {
    setOpen(false)
  }

  const handleChange = (e) => {
    if (e.target.name === "state_id" || e.target.name === "county_id") {
      if (e.target.value === null) {
        setData({
          ...data,
          [e.target.name]: null,
        })
      } else {
        setData({
          ...data,
          [e.target.name]: e.target.value.id,
        })
      }
    } else {
      setData({
        ...data,
        [e.target.name]: e.target.value,
      })
    }
  }

  const deleteFile = (index) => {
    setData({
      ...data,
      documents: data.documents.filter((item) => item !== index),
    })
  }

  const handleChangeFiles = (e) => {
    if (e.target.value.length <= 5) {
      if (
        data.documents?.length === undefined ||
        data.documents?.length === 0
      ) {
        let filesAproved = []
        for (let i = 0; i < e.target.value.length; i++) {
          if (Object.values(e.target.value)[i].size < 5000000) {
            if (
              Object.values(e.target.value)[i].type === "application/pdf" ||
              Object.values(e.target.value)[i].type ===
                "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ||
              Object.values(e.target.value)[i].type === "image/jpg" ||
              Object.values(e.target.value)[i].type === "image/png" ||
              Object.values(e.target.value)[i].type === "image/jpeg"
            ) {
              filesAproved.push(Object.values(e.target.value)[i])
            } else {
              setFileErrorType(true)
              setFileFlag(true)
            }
          } else {
            setFileErrorSize(true)
            setFileFlag(true)
          }
        }
        setData({ ...data, documents: filesAproved })
      } else {
        if (e.target.value.length <= 5 - data.documents.length) {
          let filesAproved = []
          for (let i = 0; i < e.target.value.length; i++) {
            if (Object.values(e.target.value)[i].size < 5000000) {
              if (
                Object.values(e.target.value)[i].type === "application/pdf" ||
                Object.values(e.target.value)[i].type ===
                  "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ||
                Object.values(e.target.value)[i].type === "image/jpg" ||
                Object.values(e.target.value)[i].type === "image/png" ||
                Object.values(e.target.value)[i].type === "image/jpeg"
              ) {
                filesAproved.push(Object.values(e.target.value)[i])
              } else {
                setFileErrorType(true)
                setFileFlag(true)
              }
            } else {
              setFileErrorSize(true)
              setFileFlag(true)
            }
          }
          setData({
            ...data,
            documents: data.documents.concat(filesAproved),
          })
        } else {
          setFileErrorNum(true)
          setFileFlag(true)
        }
      }
    } else {
      setFileFlag(true)
      setFileErrorNum(true)
    }
  }

  const handleDisabled = () => {
    try {
      const filtereddata = Object.entries(data).filter(
        (value) => value[0] !== "documents"
      )
      const stateFilter = Object.values(filtereddata).filter(
        (item) =>
          item[1] === undefined || item[1] === "" || item[1].length === 0
      )
      if (
        stateFilter.length > 0 ||
        isEmail(data?.email) === true ||
        data?.phone_number?.length <= 12
      ) {
        return true
      } else {
        return false
      }
    } catch (error) {
      return true
    }
  }

  if (data?.state_id === null) {
    if (data?.county_id || data?.county_id === null) {
      setData({ ...data, county_id: undefined })
    }
  } else {
    if (
      data?.county_id &&
      data?.state_id &&
      countiesList?.find((item) => item.id === data?.county_id)?.state_id !==
        data?.state_id
    ) {
      setData({ ...data, county_id: undefined })
    }
  }

  const newPqr = () => {
    setData({
      ...data,
      state_id: undefined,
      county_id: undefined,
      eps: undefined,
      ticket_type: undefined,
      settled_by: undefined,
      service: undefined,
      headquarter: undefined,
      description: undefined,
    })
    handleClose()
  }

  return isLoading ? (
    <Loader />
  ) : (
    <Box className={classes.body}>
      <BasicModal
        open={open}
        pqrType={data.ticket_type}
        eps={data.eps}
        service={data.service}
        errorModal={errorModal}
        params={params}
        ticketData={ticketData}
        newPqr={newPqr}
      />
      <Box className={classes.form}>
        <Box className={classes.formHeader}>
          <Box className={classes.headerTitle}>
            <Box className={classes.titleContainer}>
              <Typography variant="h1" className={classes.title}>
                {lists.form.title}
              </Typography>
            </Box>
            <Box className={classes.subTitle}>
              <Typography>{lists.form.subtitle}</Typography>
            </Box>
          </Box>
        </Box>
        <Box className={classes.formBody}>
          <Box className={classes.formA}>
            <Box className={classes.nameLastname}>
              <TextField
                label="Nombre y apellido *"
                variant="outlined"
                fullWidth
                name="full_name"
                onChange={handleChange}
                value={data?.full_name ? data.full_name : ""}
                error={
                  data?.full_name === undefined
                    ? false
                    : isEmpty(data?.full_name) || false
                }
              />
              <Box className={classes.errorContainer}>
                {data?.full_name === undefined
                  ? false
                  : isEmpty(data?.full_name) && (
                      <Typography variant="caption" color="error">
                        {lists.errors.required}
                      </Typography>
                    )}
              </Box>
            </Box>
            <Box className={classes.boxs}>
              <Box className={classes.age}>
                <TextField
                  label="Edad *"
                  variant="outlined"
                  name="age"
                  fullWidth
                  onInput={(e) => {
                    e.target.value = e.target.value
                      .replace(/[^0-9.]/, "")
                      .replace(/(\..*)\./g, "$1")
                  }}
                  onChange={handleChange}
                  value={data?.age ? data.age : ""}
                  error={
                    data?.age === undefined
                      ? false
                      : isEmpty(data?.age) || false
                  }
                />
                <Box className={classes.errorContainer}>
                  {data?.age === undefined
                    ? false
                    : isEmpty(data?.age) && (
                        <Typography variant="caption" color="error">
                          {lists.errors.required}
                        </Typography>
                      )}
                </Box>
              </Box>
              <Box className={classes.emailContainer}>
                <TextField
                  label="Correo electrónico *"
                  variant="outlined"
                  className={classes.email}
                  disabled={data.user_id ? true : false}
                  name="email"
                  onChange={handleChange}
                  value={data?.email ? data.email : ""}
                  error={
                    data?.email === undefined
                      ? false
                      : isEmail(data?.email) || false
                  }
                />
                <Box className={classes.errorContainer}>
                  {data?.email === undefined
                    ? false
                    : isEmpty(data?.email) && (
                        <Typography variant="caption" color="error">
                          {lists.errors.required}
                        </Typography>
                      )}
                  {isEmail(data?.email) && isEmpty(!data?.email) && (
                    <Typography variant="caption" color="error">
                      {lists.errors.invalidEmail}
                    </Typography>
                  )}
                </Box>
              </Box>
            </Box>
            <Box className={classes.boxs}>
              <Box className={classes.documentTypeContainer}>
                <Autocomplete
                  disablePortal
                  name="document_type"
                  onChange={(_, value) => {
                    handleChange({ target: { name: "document_type", value } })
                  }}
                  value={data?.document_type ? data.document_type : null}
                  options={documentTypeList?.value || []}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Tipo de documento *"
                      error={
                        data?.document_type === undefined
                          ? false
                          : isEmpty(data?.document_type) || false
                      }
                    />
                  )}
                />
                <Box className={classes.errorContainer}>
                  {data?.document_type === undefined
                    ? false
                    : isEmpty(data?.document_type) && (
                        <Typography variant="caption" color="error">
                          {lists.errors.documentType}
                        </Typography>
                      )}
                </Box>
              </Box>
              <Box className={classes.documentNumContainer}>
                <TextField
                  label="Número de documento *"
                  variant="outlined"
                  fullWidth
                  onInput={(e) => {
                    e.target.value = e.target.value
                      .replace(/[^0-9.]/, "")
                      .replace(/(\..*)\./g, "$1")
                  }}
                  name="document_number"
                  onChange={handleChange}
                  value={data?.document_number ? data.document_number : ""}
                  error={
                    data?.document_number === undefined
                      ? false
                      : isEmpty(data?.document_number) || false
                  }
                />
                <Box className={classes.errorContainer}>
                  {data?.document_number === undefined
                    ? false
                    : isEmpty(data?.document_number) && (
                        <Typography variant="caption" color="error">
                          {lists.errors.documentNum}
                        </Typography>
                      )}
                </Box>
              </Box>
            </Box>
            <Box className={classes.boxs}>
              <Box className={classes.genderContainer}>
                <Autocomplete
                  disablePortal
                  name="gender"
                  onChange={(_, value) => {
                    handleChange({ target: { name: "gender", value } })
                  }}
                  value={data?.gender ? data.gender : null}
                  options={genderList?.value || []}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Genero *"
                      error={
                        data?.gender === undefined
                          ? false
                          : isEmpty(data?.gender) || false
                      }
                    />
                  )}
                />
                <Box className={classes.errorContainer}>
                  {data?.gender === undefined
                    ? false
                    : isEmpty(data?.gender) && (
                        <Typography variant="caption" color="error">
                          {lists.errors.gender}
                        </Typography>
                      )}
                </Box>
              </Box>
              <Box className={classes.phoneContainer}>
                <MuiPhoneNumber
                  defaultCountry="co"
                  label="Número de telélefono *"
                  variant="outlined"
                  className={classes.phone}
                  name="phone_number"
                  onChange={(e) =>
                    handleChange({
                      target: { name: "phone_number", value: e },
                    })
                  }
                  value={data?.phone_number ? data.phone_number : null}
                  error={
                    data?.phone_number
                      ? data.phone_number.length <= 12
                        ? true
                        : false
                      : false
                  }
                />
                <Box className={classes.errorContainer}>
                  {data?.phone_number
                    ? data.phone_number.length <= 12 && (
                        <Typography variant="caption" color="error">
                          {lists.errors.invalidPhone}
                        </Typography>
                      )
                    : ""}
                </Box>
              </Box>
            </Box>
            <Box className={classes.direction}>
              <TextField
                label="Dirección *"
                variant="outlined"
                fullWidth
                name="address"
                onChange={handleChange}
                value={data?.address ? data.address : ""}
                error={
                  data?.address === undefined
                    ? false
                    : isEmpty(data?.address) || false
                }
              />
              <Box className={classes.errorContainer}>
                {data?.address === undefined
                  ? false
                  : isEmpty(data?.address) && (
                      <Typography variant="caption" color="error">
                        {lists.errors.required}
                      </Typography>
                    )}
              </Box>
            </Box>
            <Box className={classes.boxs}>
              <Box className={classes.stateContainer}>
                <Autocomplete
                  disablePortal
                  name="state_id"
                  onChange={(_, value) => {
                    handleChange({ target: { name: "state_id", value } })
                  }}
                  value={
                    data?.state_id
                      ? stateList.find((state) => state.id === data.state_id)
                      : null
                  }
                  options={stateList || []}
                  getOptionLabel={(option) => option?.name}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Departamento *"
                      error={
                        data?.state_id === undefined
                          ? false
                          : isEmpty(data?.state_id) || false
                      }
                    />
                  )}
                />
                <Box className={classes.errorContainer}>
                  {data?.state_id === undefined
                    ? false
                    : isEmpty(data?.state_id) && (
                        <Typography variant="caption" color="error">
                          {lists.errors.state}
                        </Typography>
                      )}
                </Box>
              </Box>
              <Box className={classes.countiesContainer}>
                <Autocomplete
                  disablePortal
                  disabled={data?.state_id ? false : true}
                  name="county_id"
                  onChange={(_, value) => {
                    handleChange({ target: { name: "county_id", value } })
                  }}
                  value={
                    data?.county_id && data?.state_id
                      ? countiesList.find(
                          (county) => county.id === data.county_id
                        )
                      : null
                  }
                  options={countiesList || []}
                  getOptionLabel={(option) => option?.name}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Municipio *"
                      error={
                        data?.county_id === undefined
                          ? false
                          : isEmpty(data?.county_id) || false
                      }
                    />
                  )}
                />
                <Box className={classes.errorContainer}>
                  {data?.county_id === undefined
                    ? false
                    : isEmpty(data?.county_id) && (
                        <Typography variant="caption" color="error">
                          {lists.errors.counties}
                        </Typography>
                      )}
                </Box>
              </Box>
            </Box>
            <Box className={classes.boxs}>
              <Box className={classes.epsContainer}>
                <Autocomplete
                  disablePortal
                  name="eps"
                  onChange={(_, value) => {
                    handleChange({ target: { name: "eps", value } })
                  }}
                  value={data?.eps ? data.eps : null}
                  options={epsList?.value || []}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="EPS *"
                      error={
                        data?.eps === undefined
                          ? false
                          : isEmpty(data?.eps) || false
                      }
                    />
                  )}
                />
                <Box className={classes.errorContainer}>
                  {data?.eps === undefined
                    ? false
                    : isEmpty(data?.eps) && (
                        <Typography variant="caption" color="error">
                          {lists.errors.eps}
                        </Typography>
                      )}
                </Box>
              </Box>
              <Box className={classes.sedeContainer}>
                <Autocomplete
                  disablePortal
                  name="headquarter"
                  onChange={(_, value) => {
                    handleChange({ target: { name: "headquarter", value } })
                  }}
                  value={data?.headquarter ? data.headquarter : null}
                  options={sedesList?.value || []}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Sede Clínica San Diego *"
                      error={
                        data?.headquarter === undefined
                          ? false
                          : isEmpty(data?.headquarter) || false
                      }
                    />
                  )}
                />
                <Box className={classes.errorContainer}>
                  {data?.headquarter === undefined
                    ? false
                    : isEmpty(data?.headquarter) && (
                        <Typography variant="caption" color="error">
                          {lists.errors.headquarter}
                        </Typography>
                      )}
                </Box>
              </Box>
            </Box>
          </Box>
          <Box className={classes.formB}>
            <Box className={classes.firstLineB}>
              <Box className={classes.pqrTypeContainer}>
                <Autocomplete
                  disablePortal
                  name="ticket_type"
                  onChange={(_, value) => {
                    handleChange({ target: { name: "ticket_type", value } })
                  }}
                  value={data?.ticket_type ? data.ticket_type : null}
                  options={pqrTypeList?.value || []}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Tipo de PQRSF *"
                      error={
                        data?.ticket_type === undefined
                          ? false
                          : isEmpty(data?.ticket_type) || false
                      }
                    />
                  )}
                />
                <Box className={classes.errorContainer}>
                  {data?.ticket_type === undefined
                    ? false
                    : isEmpty(data?.ticket_type) && (
                        <Typography variant="caption" color="error">
                          {lists.errors.pqrType}
                        </Typography>
                      )}
                </Box>
              </Box>
              <Box className={classes.whoResidesContainer}>
                <Autocomplete
                  disablePortal
                  name="settled_by"
                  onChange={(_, value) => {
                    handleChange({ target: { name: "settled_by", value } })
                  }}
                  value={data?.settled_by ? data.settled_by : null}
                  options={whoResidesList?.value || []}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Quien radica *"
                      error={
                        data?.settled_by === undefined
                          ? false
                          : isEmpty(data?.settled_by) || false
                      }
                    />
                  )}
                />
                <Box className={classes.errorContainer}>
                  {data?.settled_by === undefined
                    ? false
                    : isEmpty(data?.settled_by) && (
                        <Typography variant="caption" color="error">
                          {lists.errors.whoResides}
                        </Typography>
                      )}
                </Box>
              </Box>
            </Box>
            <Box className={classes.services}>
              <Autocomplete
                disablePortal
                name="service"
                onChange={(_, value) => {
                  handleChange({ target: { name: "service", value } })
                }}
                value={data?.service ? data.service : null}
                options={servicesList?.value || []}
                fullWidth
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Servicio al que se dirige *"
                    error={
                      data?.service === undefined
                        ? false
                        : isEmpty(data?.service) || false
                    }
                  />
                )}
              />
              <Box className={classes.errorContainer}>
                {data?.service === undefined
                  ? false
                  : isEmpty(data?.service) && (
                      <Typography variant="caption" color="error">
                        {lists.errors.service}
                      </Typography>
                    )}
              </Box>
            </Box>
            <Box className={classes.descripitionContainer}>
              <TextField
                id="outlined-basic"
                label="Descripción *"
                variant="outlined"
                fullWidth
                multiline
                rows={4.5}
                className={classes.description}
                name="description"
                onChange={handleChange}
                value={data?.description ? data.description : ""}
                error={
                  data?.description === undefined
                    ? false
                    : isEmpty(data?.description) || false
                }
              />
              <Box className={classes.errorContainerDescription}>
                {data?.description === undefined
                  ? false
                  : isEmpty(data?.description) && (
                      <Typography variant="caption" color="error">
                        {lists.errors.description}
                      </Typography>
                    )}
              </Box>
            </Box>
            <Box className={classes.fileContainer}>
              <Box className={classes.fileInput}>
                <Button
                  variant="outlined"
                  component="label"
                  className={
                    fileFlag === true
                      ? classes.addButtonError
                      : classes.addButton
                  }
                >
                  <input
                    accept=".docx, .pdf, .png, .jpg, .jpeg"
                    type="file"
                    style={{ display: "none" }}
                    onChange={(e) => {
                      handleChangeFiles({
                        target: {
                          name: "documents",
                          value: e.target.files,
                        },
                      })
                    }}
                    multiple
                  />
                  <Typography variant="caption" className={classes.addFile}>
                    Adjuntar Archivo
                  </Typography>
                  {icons("add")}
                </Button>
              </Box>
              <Box className={classes.errorContainerFiles}>
                {fileFlag === false && fileErrorNum === false && (
                  <Typography variant="caption">
                    {lists.errors.files1}
                  </Typography>
                )}
                {fileFlag === true && fileErrorSize === true && (
                  <Typography variant="caption" color="error">
                    {lists.errors.files3}
                  </Typography>
                )}
                {fileFlag === true && fileErrorType === true && (
                  <Typography variant="caption" color="error">
                    {lists.errors.files2}
                  </Typography>
                )}
                {fileFlag === true && fileErrorNum === true && (
                  <Typography variant="caption" color="error">
                    {lists.errors.files1}
                  </Typography>
                )}
              </Box>
              <Box className={classes.fileList}>
                {data?.documents &&
                  data.documents.map((file, i) => (
                    <Box
                      className={
                        data.documents.length > 3
                          ? classes.file
                          : classes.fileFullWidth
                      }
                      key={i}
                    >
                      <Box className={classes.fileNameContainer}>
                        <Box className={classes.fileName}>
                          <Typography variant="caption">{file.name}</Typography>
                        </Box>
                        <Box className={classes.fileSize}>
                          <Typography variant="caption">
                            {`(${(file.size / 1000).toFixed(0)}kb)`}
                          </Typography>
                        </Box>
                      </Box>
                      <Box className={classes.fileDelete}>
                        <IconButton
                          aria-label="delete"
                          size="small"
                          onClick={() => deleteFile(file)}
                        >
                          {icons("clear")}
                        </IconButton>
                      </Box>
                    </Box>
                  ))}
              </Box>
            </Box>
            <Box className={classes.buttons}>
              {sendingData ? (
                <Loader size={35} buttonForm={true} />
              ) : (
                <>
                  <Link to={"/"}>
                    <Button className={classes.cancel}>Cancelar</Button>
                  </Link>

                  <Button
                    variant="contained"
                    className={classes.inputButton}
                    onClick={handleSubmit}
                    disabled={handleDisabled()}
                  >
                    Enviar PQRSF
                  </Button>
                </>
              )}
            </Box>
          </Box>
        </Box>
      </Box>
      <Box className={classes.pqrTypeImg}>
        <Box className={classes.imgContainer}>
          <img src={images.formImg} className={classes.formImg} alt="logo" />
        </Box>
        <Box className={classes.pqrType}>
          <PqrType pqr={data.ticket_type} />
        </Box>
      </Box>
    </Box>
  )
}

export default Form
